export default __webpack_public_path__ + "static/media/rushmore.96d629b7.jpg";